import React from "react";
import { Row, Col ,MenuItem ,DropdownButton ,ButtonToolbar,Button,Checkbox } from 'react-bootstrap'
import Carousel from 'nuka-carousel';
import TopRating from "../TopRating/TopRating";
import FeaturesProducts from "../FeaturesProducts/FeaturesProducts";

class Filter extends React.Component {
render() {
return (
<div className="">
   <div className="product-filter">
      <div className="product-filter-name_holder">
      <span className="product-filter-name">  
      <img src={require("../../img/Product/filter-category.png")} /> 
      </span>
      <span className="product-filter-name">  Filter Category </span>
      </div>

      <ul class="product-filter__menu product-categorie">
         <li className="active-category"><a href="#">  Men Category</a></li>
         <hr/>
         <li><a href="#">Women Category</a></li>
         <hr/>
         <li><a href="#">Kids Category</a></li>
      </ul>
      <div class="product-filter__menu shop-categorie">
         <span className="product-filter-name">  Shop Category </span>
         <div className="product-filter__menu shop-type">
            <h3> Size </h3>
         </div>
         <Checkbox>Small Sizes</Checkbox>

         <Checkbox>Medium Sizes</Checkbox>
         <Checkbox>Small Sizes</Checkbox>
         <Checkbox>Large Sizes</Checkbox>
      </div>
      <div class="product-filter__menu shop-categorie">
         <div className="product-filter__menu shop-type">
            <h3> Product Style</h3>
         </div>
         <Checkbox>Classic Styles</Checkbox>
         <Checkbox>Casual Styles</Checkbox>
         <Checkbox>Big Style</Checkbox>
         <Checkbox>Flat Style</Checkbox>
         <Checkbox>Adventure Style</Checkbox>
      </div>
      <div class="product-filter__menu shop-categorie">
         <div className="product-filter__menu shop-type">
            <h3> Features</h3>
         </div>
         <Checkbox>Made In Egypt</Checkbox>
         <Checkbox>Made In Ek</Checkbox>
      </div>
     
      <div class="product-filter__menu shop-categorie">
         <div className="product-filter__menu shop-type">
    
            <h3> Brands</h3>
            <input type="text" placeholder="Search For a Brand" id="formControlsText" class="form-control"/>
         <Checkbox>Calvin Klien</Checkbox>
         <Checkbox>Zara</Checkbox>
         <Checkbox>Polo “ Ralph Lauren ”</Checkbox>
      </div>
      </div>

      <div class="product-filter__menu shop-categorie">
         <div className="product-filter__menu shop-type">
            <h3>Product Colour</h3>
         </div>
         <div className="product-filter__menu-color">
            <div className="color-item custome">
               <a href="#"> </a>
            </div>
            <h3> Red </h3>
         </div>
      </div>
      <div class="product-filter__menu shop-categorie">
         <div className="product-filter__menu shop-type">
            <h3> Top Rates</h3>
         </div>
         <Checkbox>5 Stars</Checkbox>
         <Checkbox>4 Stars</Checkbox>
         <Checkbox>3 Stars</Checkbox>
      </div>
     
      

      <TopRating/>
      <FeaturesProducts/>

               
    
   </div>
</div>
);
}
}
export default Filter;


// WEBPACK FOOTER //
// ./src/Components/Filter/Filter.jsx